define('ShopByModel.List.View',
  [
    'Backbone',
    'PageType.Base.View',
    'GlobalViews.Pagination.View',
    'GlobalViews.ShowingCurrent.View',
    'ShopByModel.Collection',
    'ShopByModel.Collection.View',
    'shop_by_model_view.tpl',
    'ListHeader.View',
    'MachineLookUp.Model',
    'Utils',
    'underscore',
    'jQuery'
  ], function (
    Backbone,
    PageTypeBaseView,
    GlobalViewsPaginationView,
    GlobalViewsShowingCurrentView,
    GoferModelCollection,
    GoferModelCollectionView,
    gofer_model_view_tpl,
    ListHeaderView,
    MachineLookUpModel,
    Utils,
    _,
    jQuery
  ) {
    'use strict';

    return PageTypeBaseView.PageTypeBaseView.extend({
      template: gofer_model_view_tpl,

      initialize: function (options) {
       
        var self = this;
        var page = '1';

        if (this.options.routerArguments && this.options.routerArguments[0]) {
          var params = Utils.parseUrlOptions(options.routerArguments[0]);

          if (params.page) {
            page = params.page.toString();
          }
        }

        this.machineCompanies = [];
        this.machineModels = [];
        this.machineLookUpModel = new MachineLookUpModel();
        this.options.page = page;
        this.collection = new GoferModelCollection();
        this.listHeader = this.setupListHeader();
        this.manufacturer = sessionStorage.getItem('manufacturer');
        this.modelType = sessionStorage.getItem('modelType');
        this.collection.on('reset', this.render, this);
        Backbone.on('resetForm',function(){
          sessionStorage.removeItem('manufacturer');
          sessionStorage.removeItem('modelType');
          self.manufacturer = "";
          self.modelType = ""
          self.refreshCollection();
        })
      },

      getEvents: function () {
        return {
          // Removed it because it causes a double call and renders for the Machines View
          // 'change [name="machine"]': 'getMachineModels',
          'click [id="mlu-find"]': 'handleSubmit',
          'change [id="machine"]': 'setManufacturer',
          'change [id="type"]': 'setModelType'
        };
      },
      setManufacturer:function setManufacturer(e){
        e.preventDefault();
       
        
        var url= document.location.href;
        window.history.pushState({}, "", url.split("?")[0]);
        if(jQuery(e.currentTarget).children('option').filter(":selected").val()){
          this.manufacturer = jQuery(e.currentTarget).children('option').filter(":selected").text().trim();
        }else{
          this.manufacturer = '';
        }
        sessionStorage.setItem('manufacturer',this.manufacturer);
        this.refreshCollection();
      },
      setModelType: function setModelType(e){
        e.preventDefault();
        if(jQuery(e.currentTarget).children('option').filter(":selected").val()){
          this.modelType = jQuery(e.currentTarget).children('option').filter(":selected").val();
        }else{
          this.modelType = '';
        }
        sessionStorage.setItem('modelType',this.modelType);
        this.refreshCollection();
      },
     
      refreshCollection: function refreshCollection(){
       
        
        var	urlOptions = _.parseUrlOptions(window.location.href);
        var data = {
          page: this.options.page || (urlOptions && urlOptions.page)
         ,goferCompany: this.manufacturer
         ,modelType:this.modelType
        };
       // console.log("🚀 ~ file: GoferModel.List.View.js:94 ~ refreshCollection ~ data", data)
        var paginationView = this.getChildViewInstance('GlobalViews.Pagination');
        var showPageView = this.getChildViewInstance('GlobalViews.ShowCurrentPage');
        this.collection.fetch({
          data: data
        }).done(function(results){
         // console.log("🚀 ~ file: GoferModel.List.View.js:76 ~ refreshCollection ~ results", results)
          
          showPageView.options.items_per_page = results.recordsPerPage;
          showPageView.options.total_items = results.totalRecordsFound;
          showPageView.options.total_pages = Math.ceil(
            results.totalRecordsFound / results.recordsPerPage
          )
          showPageView.options.flag = true;
          paginationView.options.totalPages = Math.ceil(
            results.totalRecordsFound / results.recordsPerPage
          )
           paginationView.precalculateValues();
          paginationView.render();
          showPageView.render();
        })
        
      },
      beforeShowContent: function () {
       
        var self = this;
        var args = this.options.routerArguments;
        var	urlOptions = _.parseUrlOptions(window.location.href);
        var data = {
          page: this.options.page || (urlOptions && urlOptions.page)
          ,goferCompany: this.manufacturer
          ,modelType:this.modelType
        };

        if (args && args[0]) {
          var isLocal = Backbone.history.location.href.indexOf('-local.ssp') !== -1;
          var localPath = Backbone.history.location.hash;
          var path = Backbone.history.location.pathname;
          var urlPath = isLocal ? localPath : path;
          var params = Utils.parseUrlOptions(urlPath);

          if (args[0].indexOf('page') == -1) {
            data.goferCompany = encodeURIComponent(args[0]);
          }

          // if (params.page) {
          //   data.page = params.page;
          // }
        }

        this.getBreadcrumbPages = function () {
          return [{
            text: Utils.translate('Shop by Models'),
            href: '/shop-by-model'
          }];
        };
        
        return jQuery.when(
          this.collection.fetch({
            data: data
          }),
          this.machineLookUpModel.fetch({}).done(function (results) {
           
            self.machineCompanies = _.sortBy(results.companies, 'name');
            
          })
        );
      },

      getMachineModels: function (e) {
        var self = this;
        var gfrCompany = e.target.value;

        return jQuery.when(
          this.machineLookUpModel.fetch({
            data: {
              action: 'getModels',
              gfrCompany: gfrCompany
            }
          }).done(function (results) {
            self.machineModels = _.sortBy(results, 'name');
            self.render();
          })
        );
      },

      setupListHeader: function () {
        return new ListHeaderView({
          view: this,
          application: this.options.application,
          avoidFirstFetch: true,
          collection: this.collection,
          sorts: this.sortOptions,
          page: this.options.page,
          hidePagination: true
        });
      },

      filterOptions: [
      ],

      sortOptions: [
      ],

      getChildViews: function () {
        return {
          'List.Header': function () {
            return this.listHeader;
          },
          'GoferModel.Collection.View': function () {
            return new GoferModelCollectionView({
              collection: this.collection
            });
          },
          'GlobalViews.Pagination': function () {
            return new GlobalViewsPaginationView(
              _.extend(
                {
                  totalPages: Math.ceil(
                    this.collection.totalRecordsFound / this.collection.recordsPerPage
                  )
                },
                this.options.application.getConfig().defaultPaginationSettings
              )
            );
          },
          'GlobalViews.ShowCurrentPage': function () {
            return new GlobalViewsShowingCurrentView({
              items_per_page: this.collection.recordsPerPage,
              total_items: this.collection.totalRecordsFound,
              total_pages: Math.ceil(
                this.collection.totalRecordsFound / this.collection.recordsPerPage
              ),
              flag:true
            });
          }
        };
      },

      render: _.wrap(PageTypeBaseView.PageTypeBaseView.prototype.render, function (fn) {
        var values = this.getFormValues();

        fn.apply(this, _.toArray(arguments).slice(1));

        this.setFormValues(values);

        return this;
      }),

      getFormValues: function () {
        var form = jQuery('#machine-look-up-form');
        var formData = form.serializeObject();
        return formData;
      },

      setFormValues: function (values) {
        _.each(values, function (val, key) {
          jQuery('[name=' + key + ']').val(val);
        });
      },

      getFormTextValues: function (values) {
        var results = {
          custitem_mhi_gfr_company: '',
          custitem_mhi_gfr_model: ''
        };

        var selectedCompany = _.findWhere(this.machineCompanies, { value: values.machine });
        var selectedModel = _.findWhere(this.machineModels, { value: values.model });

        results.custitem_mhi_gfr_company = selectedCompany && selectedCompany.name;
        results.custitem_mhi_gfr_model = selectedModel && selectedModel.name;

        return results;
      },

      handleSubmit: function (e) {
        e.preventDefault();
        jQuery(e.currentTarget).attr('disabled', true);
        var self = this;
        var formData = this.getFormValues();
        var selectedValues = this.getFormTextValues(formData);
        var selectedModel = selectedValues.custitem_mhi_gfr_model;
        var selectedCompany = selectedValues.custitem_mhi_gfr_company;
        var url = '';

        if (!selectedCompany) {
          jQuery(e.currentTarget).attr('disabled', false);
          return;
        }

        if (selectedModel) {
          // go to parts by selected model page
          url = 'gofer-parts/' + encodeURIComponent(selectedModel);
        } else {
          // filter down all models by selected company
          url = 'shop-by-model/' + encodeURIComponent(selectedCompany);
        }

        Backbone.history.navigate(url, { trigger: true });
      },

      getContext: function () {
        return {
          machineCompanies: this.machineCompanies,
          machineModels: this.machineModels
        };
      }
    });
  });
